import { Loader2 } from 'lucide-react';
import { STAND_META, standVon } from '../../lib/freigabe';
import type { Campaign } from '../../lib/supabase';

type Props = { campaign: Pick<Campaign, 'status' | 'review_state'>; titel?: boolean };

/** Der Stand einer Mail in einem Wort — mit dem Satz dahinter als Tooltip. */
export function FreigabeBadge({ campaign, titel = true }: Props) {
  const stand = standVon(campaign);
  const meta = STAND_META[stand];
  return (
    <span className={`badge ${meta.badge}`} title={titel ? meta.text : undefined}>
      {stand === 'wird_versendet' && <Loader2 size={11} className="spin" aria-hidden="true" />}
      {meta.label}
    </span>
  );
}
